<div>
    <da-tabs>
        <ng-container *ngIf="data">
            <ng-container *ngFor="let tab of data.tabs">
                <da-tab [tabTitle]="tab.label">
                    <div [innerHtml]="tab.section.copytext"></div>
                    <div class="boxes"></div>
                </da-tab>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="course">
            <da-tab [tabTitle]="'courses.tabTitle1' | translate" *ngIf="description">
                <div>
                    <ng-container *ngIf="site === 'de_de' && course.training.descriptionShort">
                        <h2>Kurzbeschreibung</h2>
                        <p>{{ course.training.descriptionShort }}</p>
                    </ng-container>
                    <ng-container *ngFor="let desc of description; let i=index">
                        <ng-container *ngIf="(site === 'de_de' && i !== 0 || site !== 'de_de') && (desc.paragraphs[0].text !== '' || desc.paragraphs[0].subTexts !== null)">
                            <h2 [id]="desc.name === 'VORAUSSETZUNG' ? 'prerequisites' : null">{{ desc.title }}</h2>
                            <div *ngFor="let item of desc.paragraphs">
                                <p>{{ item.text }}</p>
                                <ul *ngIf="item.subTexts">
                                    <li *ngFor="let subtext of item.subTexts">{{ subtext }}</li>
                                </ul>
                            </div>
                            <ng-container *ngIf="(showNoCourseForRequiredQualifications$ | async) && desc.name === 'VORAUSSETZUNG'">
                                <p class="error-message" [innerHTML]="noCourseForRequiredQualificationsText"></p>
                            </ng-container>
                            <ng-container *ngIf="!(showNoCourseForRequiredQualifications$ | async)">
                                <da-accordion-box *ngIf="accordion && desc.name === 'VORAUSSETZUNG'" [data]="accordion"></da-accordion-box>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="description?.length === 0 && course?.hasRequiredQualifications">
                        <ng-container *ngIf="(showNoCourseForRequiredQualifications$ | async)">
                                <p class="error-message" [innerHTML]="noCourseForRequiredQualificationsText"></p>
                            </ng-container>
                            <ng-container *ngIf="!(showNoCourseForRequiredQualifications$ | async)">
                                <da-accordion-box *ngIf="accordion" [data]="accordion"></da-accordion-box>
                            </ng-container>                        
                    </ng-container>
                </div>
                <div class="boxes"></div>
            </da-tab>
        </ng-container>
        <ng-container *ngIf="showEventTab">
                <da-tab [tabTitle]="'courses.tabTitle2' | translate">
                    <da-events *ngIf="course && course.events && course.events.length > 0" [isCourseDetails]="true" [events]="course.events" [course]="course"></da-events>
                    <p *ngIf="course && (!course.events || course.events.length === 0)" [innerHTML]="'courses.noEventsAvailable' | translate"></p>
                    <div class="boxes"></div>
                </da-tab>
        </ng-container>
    </da-tabs>
</div>
